import { Component } from '@angular/core';

@Component({
  selector: 'app-link-hub',
  templateUrl: './link-hub.component.html',
  styleUrls: ['./link-hub.component.scss']
})
export class LinkHubComponent {
  readonly phoneDisplay = '+36-30/012-1051';
  readonly phoneHref = 'tel:+36300121051';
  readonly email = 'twogetherflower@gmail.com';
  readonly website = 'https://www.twogetherflower.hu';
  readonly webshop = 'https://shop.twogetherflower.hu';
  readonly wolt = 'https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more';
  readonly googleReviewUrl = 'https://g.page/r/CU3IJBgEkVUzEBM/review';

  readonly contactVcardUrl = this.createVcardUrl();

  private createVcardUrl(): string {
    const vcard = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      'N:D&D Twogether - Flowers and more;;;',
      'FN:D&D Twogether - Flowers and more',
      'ORG:D&D Twogether - Flowers and more',
      'TEL;TYPE=CELL:+36300121051',
      'EMAIL:twogetherflower@gmail.com',
      'URL:https://www.twogetherflower.hu',
      'URL:https://shop.twogetherflower.hu',
      'URL:https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more',
      'ADR;TYPE=WORK:;;Cserhalom utca - Mura utca sarka;Budapest;;1138;Hungary',
      'END:VCARD'
    ].join('\n');

    return `data:text/vcard;charset=utf-8,${encodeURIComponent(vcard)}`;
  }
}
